/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DragIcon/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DragIcon({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/Content/BoardItem/IconAndTitle/DragIcon",
  isHovered
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let taskBoardsListTypeValueData = fromData.useDataValue({ viewPath,
context: 'task_boards_list',
path: 'type',
})
let constantData = 'private'
let aggregateData = fromAggregate.not(taskBoardsListTypeValueData, constantData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 isHovered={isHovered}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}